import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import fromExponential from 'from-exponential';

import Box from '../common/box/Box';
import i18n from '../../i18n';
import Text from '../common/text/Text';
import { colors } from '../constant';
import { renderCellExpand } from '../common/table/TableCellExpand';

const RenderEndTime = props => {
  // eslint-disable-next-line react/prop-types
  const endTime = props?.row?.endTime;
  const dateFormat = 'DD-MMM-YYYY';
  let date = new Date(endTime);
  if (date.getTimezoneOffset() > 0) {
    date = moment(date).subtract(1, 'day');
  }
  return (
    <Box>
      <DateText>{moment(date)?.format(dateFormat)}</DateText>
    </Box>
  );
};

function formatNumber(value) {
  let newValue = fromExponential(value);
  newValue = Number(newValue).toFixed(3);
  return newValue;
}

function formatNumbernotFixed(value) {
  let newValue = fromExponential(value);
  newValue = Number(newValue).toFixed();
  return newValue;
}

export const columns = [
  {
    field: 'endTime',
    headerName: i18n.t('recordDate'),
    sortable: false,
    disableColumnMenu: true,
    flex: 1,
    renderCell: params => RenderEndTime(params)
  },

  {
    field: 'activeStorage',
    headerName: i18n.t('activeStorageTB'),
    disableColumnMenu: true,
    sortable: false,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumber(params.row.activeStorage).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  },
  {
    field: 'deletedStorage',
    headerName: i18n.t('deletedStorageTB'),
    disableColumnMenu: true,
    sortable: false,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumber(params.row.deletedStorage).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  },
  {
    field: 'activeObjects',
    headerName: i18n.t('activeObjects'),
    sortable: false,
    disableColumnMenu: true,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumbernotFixed(params.row.activeObjects).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  },
  {
    field: 'deletedObjects',
    headerName: i18n.t('deletedObjects'),
    sortable: false,
    disableColumnMenu: true,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumbernotFixed(params.row.deletedObjects).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  },
  {
    field: 'apiCalls',
    headerName: i18n.t('apiCalls'),
    sortable: false,
    disableColumnMenu: true,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumbernotFixed(params.row.apiCalls).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  },
  {
    field: 'egress',
    headerName: i18n.t('egressGB'),
    disableColumnMenu: true,
    sortable: false,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumber(params.row.egress).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  },
  {
    field: 'ingress',
    headerName: i18n.t('ingressGB'),
    disableColumnMenu: true,
    sortable: false,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumber(params.row.ingress).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  },
  {
    field: 'storageWrote',
    headerName: i18n.t('storageWroteTB'),
    disableColumnMenu: true,
    sortable: false,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumber(params.row.storageWrote).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  },
  {
    field: 'storageRead',
    headerName: i18n.t('storageReadTB'),
    disableColumnMenu: true,
    sortable: false,
    flex: 1,
    renderCell: params =>
      renderCellExpand({
        value: formatNumber(params.row.storageRead).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        ),
        width: params,
        color: colors.gray20
      })
  }
];

export const DateText = styled(Text)(
  ({ theme }) => `
    color: ${theme.themes?.colorPrimary};
    font-weight: 500;
`
);
